import { render, staticRenderFns } from "./GenericIconInput.vue?vue&type=template&id=38702710&scoped=true"
import script from "./GenericIconInput.vue?vue&type=script&lang=ts"
export * from "./GenericIconInput.vue?vue&type=script&lang=ts"
import style0 from "./GenericIconInput.vue?vue&type=style&index=0&id=38702710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38702710",
  null
  
)

export default component.exports